import { render, staticRenderFns } from "./SettingEmployeeLayout.vue?vue&type=template&id=6e8d6db6&scoped=true&"
import script from "./SettingEmployeeLayout.vue?vue&type=script&lang=js&"
export * from "./SettingEmployeeLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingEmployeeLayout.vue?vue&type=style&index=0&id=6e8d6db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8d6db6",
  null
  
)

component.options.__file = "SettingEmployeeLayout.vue"
export default component.exports